import { useRef, useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import './ProductSection.css';

const ProductSection = ({ section, sectionIndex, innerRef }) => {
  const sectionEl = useRef(null);
  const [inView, setInView] = useState(false);

  // Detect when the section enters the viewport
  useEffect(() => {
    const el = sectionEl.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // Merge refs (innerRef for sticky stack + local ref for IntersectionObserver)
  const setRefs = (el) => {
    sectionEl.current = el;
    if (typeof innerRef === 'function') innerRef(el);
  };

  return (
    <section
      className={`product-section${inView ? ' product-section--in-view' : ''}`}
      ref={setRefs}
    >
      <Carousel slides={section.slides} sectionIndex={sectionIndex} inView={inView} />
    </section>
  );
};

export default ProductSection;
